<template>
    <transition name="fade">
        <section class="modal-section">
            <div class="disp-modal aqa-modal cross-absolute section_trashcan">
                <div class="container">
                    <div class="trashcan-modal-wrap">
                        <div class="modal-overlay black" @click="closeDeletedQuizzesModal()"></div>
                        <div class="modal-content-wrap trashcan-modal-body trashcan_m_b">
                            <div class="payment_popup_close cross-absolute" @click="closeDeletedQuizzesModal()" id="close_lead_modal" @keyup.esc="closeDeletedQuizzesModal()" @keyup.enter="closeDeletedQuizzesModal()">
                            </div>
                            <div class="trashcan_header">
                                <h3 class="trashcan_title">{{ $t('trashcanTitle') }}</h3>
                                <div class="trashcan_two_sides">
                                    <p><span class="trashcan_important">{{ $t('trashcanImportant') }}</span>{{ $t('trashcanDescription') }}</p>
                                    <!-- <button class="trashcan_delete-all" @click="trashcanClearAll()">
                                        {{ $t('trashcanClearAll') }}
                                        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="16" viewBox="0 0 16 16" fill="none">
                                            <path d="M14.875 2.46154H1.125C0.95924 2.46154 0.800269 2.52637 0.683058 2.64178C0.565848 2.75719 0.5 2.91371 0.5 3.07692C0.5 3.24013 0.565848 3.39666 0.683058 3.51207C0.800269 3.62747 0.95924 3.69231 1.125 3.69231H1.75V14.7692C1.75 15.0957 1.8817 15.4087 2.11612 15.6395C2.35054 15.8703 2.66848 16 3 16H13C13.3315 16 13.6495 15.8703 13.8839 15.6395C14.1183 15.4087 14.25 15.0957 14.25 14.7692V3.69231H14.875C15.0408 3.69231 15.1997 3.62747 15.3169 3.51207C15.4342 3.39666 15.5 3.24013 15.5 3.07692C15.5 2.91371 15.4342 2.75719 15.3169 2.64178C15.1997 2.52637 15.0408 2.46154 14.875 2.46154ZM13 14.7692H3V3.69231H13V14.7692ZM4.25 0.615385C4.25 0.452174 4.31585 0.295649 4.43306 0.180242C4.55027 0.064835 4.70924 0 4.875 0H11.125C11.2908 0 11.4497 0.064835 11.5669 0.180242C11.6842 0.295649 11.75 0.452174 11.75 0.615385C11.75 0.778595 11.6842 0.93512 11.5669 1.05053C11.4497 1.16593 11.2908 1.23077 11.125 1.23077H4.875C4.70924 1.23077 4.55027 1.16593 4.43306 1.05053C4.31585 0.93512 4.25 0.778595 4.25 0.615385Z" fill="#B22222"/>
                                        </svg>
                                    </button> -->
                                </div>
                            </div>
                            <div class="trashcan_body">
                                <div v-for="(quiz, index) in deletedQuizzes" :key="quiz.id" class="quiz-slot" :id="'workboard_quiz_' + quiz.id">
                                    <div class="quiz-slot_handler">
                                    <span class="c-ctrl-s_move handle inactive" title="Move"></span>
                                    </div>
                                    <div class="quiz-slot_wrap">
                                        <div class="quiz-slot_body">
                                            <span class="quiz-slot_date">{{ $t('quizSlotDeletedData') }}: {{ quiz.deleted_at }}</span>
                                            <h4 class="quiz-slot_title" :title="quiz.name" >
                                            {{ quiz.name }}
                                            </h4>
                                        </div>
                                        <div class="quiz-slot_footer">
                                            <div class="quiz-slot_foter_main-action">
                                                <button class="qs_restore-button"
                                                    @click="restoreQuiz(quiz.id, index)">
                                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M12.7501 7.49997V11.5753L16.1363 13.6068C16.3069 13.7093 16.4298 13.8753 16.478 14.0683C16.5261 14.2614 16.4956 14.4657 16.3932 14.6362C16.2908 14.8068 16.1248 14.9297 15.9317 14.9778C15.7387 15.026 15.5344 14.9955 15.3638 14.8931L11.6138 12.6431C11.5028 12.5764 11.411 12.4821 11.3473 12.3694C11.2835 12.2567 11.25 12.1294 11.2501 12V7.49997C11.2501 7.30106 11.3291 7.11029 11.4697 6.96964C11.6104 6.82899 11.8012 6.74997 12.0001 6.74997C12.199 6.74997 12.3898 6.82899 12.5304 6.96964C12.6711 7.11029 12.7501 7.30106 12.7501 7.49997ZM21.0001 5.24997C20.8012 5.24997 20.6104 5.32899 20.4697 5.46964C20.3291 5.61029 20.2501 5.80106 20.2501 5.99997V7.68747C19.6548 6.99747 19.0473 6.33278 18.3638 5.64091C17.1131 4.39001 15.5214 3.53543 13.7877 3.18396C12.0541 2.83249 10.2552 2.99971 8.61606 3.66472C6.97688 4.32974 5.57002 5.46306 4.57126 6.92307C3.57251 8.38309 3.02615 10.1051 3.00046 11.8738C2.97477 13.6426 3.47089 15.3797 4.42682 16.8681C5.38275 18.3565 6.7561 19.5302 8.37528 20.2425C9.99445 20.9549 11.7876 21.1743 13.5308 20.8733C15.274 20.5723 16.8898 19.7643 18.1763 18.5503C18.248 18.4826 18.3056 18.4014 18.3459 18.3114C18.3862 18.2214 18.4083 18.1244 18.4111 18.0259C18.4139 17.9273 18.3972 17.8292 18.3621 17.7371C18.327 17.645 18.274 17.5607 18.2063 17.489C18.1386 17.4174 18.0574 17.3598 17.9675 17.3195C17.8775 17.2792 17.7805 17.257 17.6819 17.2542C17.5834 17.2515 17.4852 17.2681 17.3931 17.3032C17.301 17.3384 17.2167 17.3913 17.1451 17.459C16.0726 18.4697 14.7262 19.1421 13.2739 19.3921C11.8216 19.6422 10.3278 19.4589 8.97908 18.865C7.63036 18.2712 6.48646 17.2932 5.69024 16.0532C4.89402 14.8131 4.48075 13.366 4.50205 11.8925C4.52336 10.419 4.97828 8.98439 5.81001 7.76788C6.64175 6.55138 7.81344 5.60685 9.17876 5.05226C10.5441 4.49767 12.0425 4.3576 13.487 4.64952C14.9315 4.94145 16.2579 5.65245 17.3007 6.69372C18.0638 7.46622 18.7323 8.2106 19.4063 8.99997H17.2501C17.0512 8.99997 16.8604 9.07899 16.7197 9.21964C16.5791 9.36029 16.5001 9.55106 16.5001 9.74997C16.5001 9.94888 16.5791 10.1396 16.7197 10.2803C16.8604 10.421 17.0512 10.5 17.2501 10.5H21.0001C21.199 10.5 21.3898 10.421 21.5304 10.2803C21.6711 10.1396 21.7501 9.94888 21.7501 9.74997V5.99997C21.7501 5.80106 21.6711 5.61029 21.5304 5.46964C21.3898 5.32899 21.199 5.24997 21.0001 5.24997Z" fill="#3749C0"/>
                                                    </svg>
                                                    <p>{{ $t("trashcanRestoreQuiz") }}</p>
                                                </button>
                                            </div>
                                            <div class="quiz-slot_foter_additional-action">
                                                <!-- <button
                                                    class="qs_delete-button"
                                                    @click="openModalLastDeleteQuiz(quiz.id, index)">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="16" viewBox="0 0 16 16" fill="none">
                                                        <path d="M14.875 2.46154H1.125C0.95924 2.46154 0.800269 2.52637 0.683058 2.64178C0.565848 2.75719 0.5 2.91371 0.5 3.07692C0.5 3.24013 0.565848 3.39666 0.683058 3.51207C0.800269 3.62747 0.95924 3.69231 1.125 3.69231H1.75V14.7692C1.75 15.0957 1.8817 15.4087 2.11612 15.6395C2.35054 15.8703 2.66848 16 3 16H13C13.3315 16 13.6495 15.8703 13.8839 15.6395C14.1183 15.4087 14.25 15.0957 14.25 14.7692V3.69231H14.875C15.0408 3.69231 15.1997 3.62747 15.3169 3.51207C15.4342 3.39666 15.5 3.24013 15.5 3.07692C15.5 2.91371 15.4342 2.75719 15.3169 2.64178C15.1997 2.52637 15.0408 2.46154 14.875 2.46154ZM13 14.7692H3V3.69231H13V14.7692ZM4.25 0.615385C4.25 0.452174 4.31585 0.295649 4.43306 0.180242C4.55027 0.064835 4.70924 0 4.875 0H11.125C11.2908 0 11.4497 0.064835 11.5669 0.180242C11.6842 0.295649 11.75 0.452174 11.75 0.615385C11.75 0.778595 11.6842 0.93512 11.5669 1.05053C11.4497 1.16593 11.2908 1.23077 11.125 1.23077H4.875C4.70924 1.23077 4.55027 1.16593 4.43306 1.05053C4.31585 0.93512 4.25 0.778595 4.25 0.615385Z" fill="#B22222"/>
                                                    </svg>
                                                </button> -->
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </transition>
</template>

<script>
import axios from 'axios'
export default {
    props: {
        userInfo: {
            type: Object,
            required: true,
        },
        isOpenedDeletedQuizModal: {
            type: Boolean,
        }
    },
    data() {
        return {
            baseBackendUrl: process.env.VUE_APP_BASE_URL,
            baseUserIdent: process.env.VUE_APP_USER_IDENT,
            deletedQuizzes: [{
                id: "316",
                domain: "tarry.ml",
                deleted_at: "2023-10-21 15:20:06",
                name: "tarry.ml"
            }]
        };
    },
    computed: {
        locale_lang() {
            if (this.$i18n.locale == "UA") {
                return "UK"
            } else {
                return this.$i18n.locale
            }
        },
    },
    methods: {
        closeDeletedQuizzesModal() {
            this.$emit('close-deleted-quizzes-modal');
        },
        restoreQuizSended() {
            this.$emit('restore-quiz-sended');
        },
        getDeletedQuiz() {
            this.fullScreenLoader = true
            var data = JSON.stringify({
                query: `query { 
                    quizzes(
                        is_deleted: true,
                        limit: 100,
                        user_id: "${this.userInfo.id}"
                    ) {
                        data {
                            id
                            domain
                            deleted_at
                            name
                        }
                    }
                }`,
                variables: {}
            });

            var config = {
                method: 'post',
                url: this.baseBackendUrl + '/graphql',
                headers: {
                    'Content-Type': 'application/json'
                },
                data: data
            };

            axios(config)
                .then(response => {
                    this.deletedQuizzes = response.data.data.quizzes.data
                    this.errorAuth(response.status)
                })
                .catch(error => {
                    console.log(error);
                    this.errorAuth(error.response.status)
                });
        },
        restoreQuiz(quiz_id, index) {
            var data = JSON.stringify({
            query: `mutation {
                restoreQuiz(
                    id: "${quiz_id}"
                )
            }`,
            variables: {}

        });

        var config = {
            method: 'post',
            url: this.baseBackendUrl + '/graphql/',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            data: data
        };

        axios(config)
            .then((response) => {
                console.log(response)
                if (response.data.data.restoreQuiz) {
                    this.deletedQuizzes.splice(index, 1)
                    this.restoreQuizSended()
                }
            })
            .catch (error => {
                this.$notify({
                    title: 'FAILED',
                    type: 'error'
                });
                console.log(error);
            })
        },
        trashcanClearAll() {
            
        }
    },
    mounted() {
    },
    watch: {
        isOpenedDeletedQuizModal() {
            if (this.isOpenedDeletedQuizModal) {
                this.getDeletedQuiz()
            } 
        }
    }
}
</script>

<style>
.trashcan-modal-wrap {
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
}

.trashcan_header {
    margin-bottom: 24px;
}

.trashcan_body {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 20px;
    overflow: auto;
}

.trashcan_title {
    margin-bottom: 8px;
}

.trashcan_two_sides {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    gap: 24px;
}



.quiz-slot {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: space-between;
    width: calc(50% - 10px);
    border-radius: 10px;
    margin: 0;
    overflow: hidden;
}
  .quiz-slot_handler {
    width: 32px;
    height: auto;
    padding: 16px 8px;
  }

  .quiz-slot_wrap {
    position: relative;
    width: calc(100% - 16px);
    display: flex;
    flex-direction: column;
  }

  .quiz-slot_wrap .quiz-link_wrap {
    position: absolute;
    top: 16px;
    right: 16px;
  }

  .quiz-slot_body {
    display: flex;
    flex-direction: column;
    padding: 16px 16px 20px 16px;
  }

  .quiz-slot_title {
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    padding-right: 16px;
  }

  .quiz-slot_footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 16px;
  }

  .quiz-slot_foter_main-action {
    display: flex;
    align-items: center;
    width: calc(100% - 50px);
  }

  /* .quiz-slot_foter_main-action button {
    margin-right: 24px;
    height: 24px;
    width: 24px;
    padding: 0;
    background: transparent;
    border: none;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  } */

  .quiz-slot_foter_main-action .qs_restore-button {
    width: auto;
    display: flex;
    align-items: center;
    border: none;
    background: none;
    padding: 0;
    cursor: pointer;
  }

.quiz-slot_foter_main-action button:last-of-type {
  margin-right: 0;
}

.quiz-slot_foter_additional-action button {
  height: 24px;
  width: 24px;
  padding: 0;
  background: transparent;
  border: none;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
/* @media screen and (max-width: 2000px) {
  .quiz-slot {
      width: calc(25% - 15px);
  }
}
@media screen and (max-width: 1400px) {
  .quiz-slot {
      width: calc(33% - 13px);
  }
}

@media screen and (max-width: 980px) {
  .quiz-slot {
      width: calc(50% - 10px);
  }
} */

@media screen and (max-width: 620px) {
  .quiz-slot {
      width: calc(100%);
  }
}

  
</style>
  